import { ArrowRight, MapPin } from 'lucide-react';
import { displayTitle } from '../data/website';
import { Dialog, DialogContent, DialogTitle, DialogDescription } from './ui/dialog';

export const DiscoveryModal = ({ item, onClose, onPlan }) => <Dialog open={Boolean(item)} onOpenChange={open => { if (!open) onClose(); }}>
  <DialogContent className="discovery-modal" data-testid="discovery-modal" closeTestId="discovery-modal-close">
    {item && <>
      <img src={item.image} alt={`Illustrative ${displayTitle(item.title)} imagery`} className="discovery-image" data-testid="discovery-image" />
      <div className="discovery-content">
        <p className="eyebrow" data-testid="discovery-category">{item.category}</p>
        <DialogTitle className="discovery-title" data-testid="discovery-title">{displayTitle(item.title)}</DialogTitle>
        <DialogDescription className="discovery-description" data-testid="discovery-description">{item.description}</DialogDescription>
        {item.location && <p className="discovery-meta" data-testid="discovery-location"><span><MapPin size={15} />{item.location}</span></p>}
        <p className="discovery-image-note" data-testid="discovery-image-caption">{item.imageCaption}</p>
        <div className="discovery-tags" data-testid="discovery-tags">{item.tags?.map(tag => <span key={tag}>{tag}</span>)}</div>
        <button className="button button-dark" onClick={() => { onClose(); onPlan(item.title); }} data-testid="discovery-plan-journey">{item.location ? 'Enquire About 7D Cinema' : 'Get in Touch'}<ArrowRight size={17} /></button>
      </div>
    </>}
  </DialogContent>
</Dialog>;